import { Theme, alpha } from '@mui/material/styles';

export const createMarkdownStyles = (theme: Theme) => ({
    fontFamily: theme.typography.fontFamily,
    '.wmde-markdown': {
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        fontSize: '14px',
        '& h1': {
            borderBottom: `0px solid ${alpha(theme.palette.text.primary, 0.5)}`,
        },
        '& h2': {
            borderBottom: `0px solid ${alpha(theme.palette.text.primary, 0.5)}`,
        },
        '& a': {
            color: theme.palette.info.main,
        },
        '& p:empty::after': {
            content: '""',
            display: 'block',
            height: '1em',
        },
        'input[type="checkbox"]': {
            appearance: 'none',
            width: '16px',
            height: '16px',
            border: `2px solid ${alpha(theme.palette.text.secondary, 0.7)}`,
            borderRadius: '2px',
            backgroundColor: theme.palette.background.paper,
            cursor: 'pointer',
            userSelect: 'none',
            '&:checked': {
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
                backgroundImage: () => {
                    const encodedColor = encodeURIComponent(theme.palette.primary.contrastText);
                    return `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='${encodedColor}' stroke='${encodedColor}' stroke-width='1'%3E%3Cpath d='M9.75 16.5L5.25 12l-1.75 1.75L9.75 20 21.25 8.5 19.5 6.75z'/%3E%3C/svg%3E")`;
                },
                backgroundSize: '14px',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            },
            '&:hover:not(:checked)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
        '& .contains-task-list': {
            marginTop: '0.5em',
        },
    },
    '.w-md-editor': {
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        boxShadow: "none",
        "--md-editor-box-shadow-color": theme.palette.divider,
        fontFamily: `${theme.typography.fontFamily} !important`,
        '*': {
            // fontFamily: `${theme.typography.fontFamily} !important`,
        },
        textarea: {
            // fontFamily: `${theme.typography.fontFamily} !important`,
        }
    },
    '.w-md-editor-text': {
        fontFamily: `${theme.typography.fontFamily} !important`,
        height: '100%%',
    },
    '.w-md-editor-text-pre': {
        fontFamily: `${theme.typography.fontFamily} !important`,
        fontSize: '14px !important',
    },
    '.w-md-editor-text-input': {
        fontFamily: `${theme.typography.fontFamily} !important`,
        fontSize: '14px !important',
    },
    '.w-md-editor-toolbar': {
        // position: "sticky",
        // top: "82px",
        // zIndex: 1000,
        backgroundColor: theme.palette.background.paper,
        svg: {
            color: alpha(theme.palette.text.primary, 0.8),
        },
    },
    '.w-md-editor-preview p': {
        whiteSpace: 'pre-line'
    },
    '.w-md-editor-preview': {
        fontFamily: theme.typography.fontFamily,
    },
    'li p': {
        marginBottom: '0.3em',
        marginTop: '0.3em',
    },
    '.w-md-editor-text-pre > code, .w-md-editor-text-pre > code *': {
        // fontFamily: `${theme.typography.fontFamily} !important`,
        // fontSize: '12px !important',
    },
    'code, pre, textarea': {
        fontFamily: `${theme.typography.fontFamily} !important`,
        color: alpha(theme.palette.text.primary, 0.8),
    },
    'hr': {
        borderColor: alpha(theme.palette.common.black, 0.6),
        margin: '1em 0',
        marginTop: '0.3em',
        borderWidth: '2px',
    },
    'table': {
        margin: '1em 0',
        border: `1px solid ${alpha(theme.palette.text.primary, 0.2)}`,
        'th, td': {
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${alpha(theme.palette.text.primary, 0.2)}`,
        },
    }
}) as const;
